import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"overflow":"auto"}
}
const _hoisted_2 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "text-start p-sm" }
const _hoisted_4 = { class: "text-start p-sm" }
const _hoisted_5 = {
  class: "",
  style: {"width":"25px"}
}
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-sm" }
const _hoisted_9 = { class: "d-flex align-items-center gap-sm" }
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  class: "p-sm"
}
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = {
  key: 1,
  class: "p-sm"
}
const _hoisted_14 = {
  key: 2,
  class: "p-sm"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "text-end p-sm" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-sm"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center gap-sm"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  colspan: "4",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_AndroidAppsPopup = _resolveComponent("AndroidAppsPopup")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "",
    title: _ctx.$t('labels.devices'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("th", { class: "text-start p-sm" }, null, -1)),
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: ""
                  }, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          style: {},
                          src: require(`@/apps/public/assets/img/device-${item.status}.svg`)
                        }, null, 8, _hoisted_7)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (item.id)
                          ? _withDirectives((_openBlock(), _createElementBlock("span", {
                              key: 0,
                              style: {"font-family":"monospace"},
                              title: item.id
                            }, [
                              _createTextVNode(_toDisplayString(item.id.substring(0, 5)), 1)
                            ], 8, _hoisted_10)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          : _createCommentVNode("", true),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        (item.id)
                          ? (_openBlock(), _createBlock(_component_copy_button, {
                              key: 1,
                              value: item.id
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (!item.id)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                            style: {"min-width":"100px"},
                            class: "form-control form-control-sm"
                          }, null, 8, _hoisted_12), [
                            [_vModelText, item.name]
                          ])
                        ]))
                      : (_ctx.currentEditDevice && _ctx.currentEditDevice.id === item.id)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              style: {"min-width":"100px"},
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentEditDevice.name) = $event)),
                              class: "form-control form-control-sm"
                            }, null, 512), [
                              [_vModelText, _ctx.currentEditDevice.name]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_14, [
                            _withDirectives(_createElementVNode("i", {
                              title: _ctx.helper.trans(`labels.${item.status}_since`, {date: item.statusUpdatedAt ? _ctx.dateHelper.format(item.statusUpdatedAt) : 'n/a'}),
                              style: {"font-size":"70%"},
                              class: _normalizeClass([{'text-success': item.status === 'online', 'text-secondary': item.status === 'offline'}, "fa-solid fa-circle"])
                            }, null, 10, _hoisted_15), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ]),
                            _createTextVNode(" " + _toDisplayString(item.name), 1)
                          ])),
                    _createElementVNode("td", _hoisted_16, [
                      (!item.id || _ctx.currentEditDevice && _ctx.currentEditDevice.id === item.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_LoaderButton, {
                              type: "button",
                              "on-click": () => (_ctx.save(index)),
                              class: "btn detail__btn"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createElementVNode("svg", {
                                  width: "20",
                                  height: "21",
                                  viewBox: "0 0 20 21",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M15.2044 7.14856L8.74285 14.8409C8.67197 14.9253 8.58377 14.9935 8.48423 15.0409C8.3847 15.0882 8.27614 15.1136 8.16592 15.1154H8.15294C8.04512 15.1154 7.93852 15.0926 7.84004 15.0488C7.74156 15.0049 7.65341 14.9407 7.58131 14.8606L4.81208 11.7837C4.74175 11.7091 4.68704 11.6212 4.65117 11.5251C4.61529 11.4291 4.59898 11.3269 4.60319 11.2244C4.60739 11.122 4.63203 11.0214 4.67565 10.9287C4.71927 10.8359 4.781 10.7528 4.85721 10.6842C4.93341 10.6156 5.02256 10.5629 5.1194 10.5293C5.21625 10.4957 5.31884 10.4817 5.42115 10.4883C5.52346 10.4949 5.62342 10.5219 5.71515 10.5676C5.80689 10.6134 5.88856 10.677 5.95535 10.7548L8.13275 13.174L14.0265 6.15914C14.1587 6.0063 14.3457 5.91161 14.5472 5.89556C14.7486 5.87951 14.9483 5.94337 15.1031 6.07336C15.2578 6.20334 15.3552 6.38899 15.3741 6.59019C15.3931 6.79139 15.3321 6.99196 15.2044 7.14856Z",
                                    fill: "#F7F9FC"
                                  })
                                ], -1)
                              ])),
                              _: 2,
                              __: [6]
                            }, 1032, ["on-click"]),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.cancel(index)),
                              class: "btn detail__btn"
                            }, _cache[7] || (_cache[7] = [
                              _createElementVNode("svg", {
                                width: "20",
                                height: "21",
                                viewBox: "0 0 20 21",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M5.96496 5.40402L15.096 14.535C16.0855 13.2853 16.5814 11.7156 16.4893 10.1242C16.3972 8.53283 15.7235 7.03078 14.5964 5.90362C13.4692 4.77646 11.9672 4.10279 10.3758 4.01068C8.78439 3.91856 7.21464 4.41444 5.96496 5.40402ZM14.035 15.596L4.90396 6.46502C3.91438 7.7147 3.4185 9.28445 3.51062 10.8758C3.60273 12.4672 4.2764 13.9693 5.40356 15.0964C6.53072 16.2236 8.03277 16.8973 9.62415 16.9894C11.2155 17.0815 12.7853 16.5856 14.035 15.596ZM4.34296 4.84302C5.08585 4.10014 5.96779 3.51084 6.93842 3.1088C7.90905 2.70675 8.94936 2.49982 9.99996 2.49982C11.0506 2.49982 12.0909 2.70675 13.0615 3.1088C14.0321 3.51084 14.9141 4.10014 15.657 4.84302C16.3998 5.58591 16.9891 6.46785 17.3912 7.43848C17.7932 8.40911 18.0002 9.44942 18.0002 10.5C18.0002 11.5506 17.7932 12.5909 17.3912 13.5616C16.9891 14.5322 16.3998 15.4141 15.657 16.157C14.1566 17.6574 12.1217 18.5002 9.99996 18.5002C7.87818 18.5002 5.84329 17.6574 4.34296 16.157C2.84263 14.6567 1.99976 12.6218 1.99976 10.5C1.99976 8.37824 2.84263 6.34335 4.34296 4.84302Z",
                                  fill: "#F7F9FC"
                                })
                              ], -1)
                            ]), 8, _hoisted_18)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = () => {}),
                              class: "btn detail__btn"
                            }, _cache[8] || (_cache[8] = [
                              _createElementVNode("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M3.505 2.365C5.32653 2.12142 7.16226 1.99948 9 2C10.863 2 12.697 2.124 14.495 2.365C15.742 2.532 16.675 3.473 16.93 4.633C16.7394 4.59745 16.5466 4.57441 16.353 4.564C14.7855 4.47838 13.2145 4.47838 11.647 4.564C9.229 4.696 7.5 6.727 7.5 8.998V11.238C7.5 12.651 8.17 13.973 9.26 14.8L6.28 17.78C6.17511 17.8848 6.04153 17.9561 5.89614 17.985C5.75074 18.0139 5.60004 17.999 5.46308 17.9423C5.32611 17.8856 5.20903 17.7895 5.12661 17.6663C5.04419 17.5431 5.00013 17.3982 5 17.25V13.807C4.499 13.759 4 13.701 3.505 13.635C2.033 13.438 1 12.162 1 10.72V5.28C1 3.839 2.033 2.562 3.505 2.365Z",
                                  fill: "#F7F9FC"
                                }),
                                _createElementVNode("path", {
                                  d: "M14 6C13.238 6 12.48 6.02 11.729 6.062C10.157 6.148 9 7.472 9 8.998V11.238C9 12.757 10.147 14.077 11.71 14.173C11.924 14.186 12.138 14.197 12.352 14.207C12.552 14.216 12.737 14.297 12.87 14.431L15.22 16.781C15.3249 16.8858 15.4586 16.9572 15.6041 16.986C15.7496 17.0149 15.9004 16.9999 16.0374 16.9431C16.1744 16.8863 16.2915 16.7901 16.3738 16.6667C16.4562 16.5433 16.5001 16.3983 16.5 16.25V14.18C17.953 13.985 19 12.717 19 11.265V8.998C19 7.472 17.843 6.148 16.271 6.062C15.5147 6.02068 14.7574 6.00001 14 6Z",
                                  fill: "#F7F9FC"
                                })
                              ], -1)
                            ])),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.showApps(item)),
                              class: "btn detail__btn"
                            }, _cache[9] || (_cache[9] = [
                              _createElementVNode("svg", {
                                height: "20",
                                width: "20",
                                fill: "none",
                                version: "1.1",
                                id: "Layer_1",
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                viewBox: "0 0 413.137 413.137",
                                "xml:space": "preserve"
                              }, [
                                _createElementVNode("g", null, [
                                  _createElementVNode("path", {
                                    style: {"fill":"#F7F9FC"},
                                    d: "M311.358,136.395H101.779c-4.662,0-8.441,3.779-8.441,8.441v175.749\n\t\tc0,4.662,3.779,8.441,8.441,8.441h37.363v59.228c0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883\n\t\tv-59.228h34.803v59.228c0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883v-59.228h37.882\n\t\tc4.662,0,8.441-3.779,8.441-8.441V144.836C319.799,140.174,316.02,136.395,311.358,136.395z"
                                  }),
                                  _createElementVNode("path", {
                                    style: {"fill":"#F7F9FC"},
                                    d: "M57.856,136.354L57.856,136.354c-13.742,0-24.883,11.14-24.883,24.883v101.065\n\t\tc0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883V161.237\n\t\tC82.738,147.495,71.598,136.354,57.856,136.354z"
                                  }),
                                  _createElementVNode("path", {
                                    style: {"fill":"#F7F9FC"},
                                    d: "M355.281,136.354L355.281,136.354c-13.742,0-24.883,11.14-24.883,24.883v101.065\n\t\tc0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883V161.237\n\t\tC380.164,147.495,369.024,136.354,355.281,136.354z"
                                  }),
                                  _createElementVNode("path", {
                                    style: {"fill":"#F7F9FC"},
                                    d: "M103.475,124.069h205.692c5.366,0,9.368-4.943,8.266-10.195\n\t\tc-6.804-32.428-27.45-59.756-55.465-75.543l17.584-31.727c1.19-2.148,0.414-4.855-1.734-6.045\n\t\tc-2.153-1.193-4.856-0.414-6.046,1.734l-17.717,31.966c-14.511-6.734-30.683-10.495-47.734-10.495\n\t\tc-17.052,0-33.224,3.761-47.735,10.495L140.869,2.292c-1.191-2.149-3.898-2.924-6.045-1.734c-2.148,1.19-2.924,3.897-1.734,6.045\n\t\tl17.584,31.727c-28.015,15.788-48.661,43.115-55.465,75.544C94.106,119.126,98.108,124.069,103.475,124.069z M267.697,76.786\n\t\tc0,5.282-4.282,9.565-9.565,9.565c-5.282,0-9.565-4.282-9.565-9.565c0-5.282,4.282-9.565,9.565-9.565\n\t\tC263.415,67.221,267.697,71.504,267.697,76.786z M154.508,67.221c5.282,0,9.565,4.282,9.565,9.565c0,5.282-4.282,9.565-9.565,9.565\n\t\tc-5.282,0-9.565-4.282-9.565-9.565C144.943,71.504,149.225,67.221,154.508,67.221z"
                                  })
                                ])
                              ], -1)
                            ]), 8, _hoisted_20),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.edit(item)),
                              class: "btn detail__btn"
                            }, _cache[10] || (_cache[10] = [
                              _createElementVNode("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M1.43302 17.9172L2.69502 14.7622C2.89605 14.2592 3.19714 13.8023 3.58002 13.4192L13.9898 3.01046L16.9903 6.01046L6.58102 16.4192C6.19799 16.8025 5.74108 17.1039 5.23802 17.3052L2.08302 18.5672C1.99216 18.6036 1.89262 18.6125 1.79674 18.5928C1.70087 18.5731 1.61287 18.5258 1.54366 18.4566C1.47446 18.3874 1.42708 18.2994 1.40742 18.2035C1.38775 18.1076 1.39665 18.0081 1.43302 17.9172Z",
                                  fill: "#F7F9FC"
                                }),
                                _createElementVNode("path", {
                                  d: "M18.1213 4.0012C18.1213 4.56381 17.8978 5.10338 17.5 5.5012L14.5 2.5012C14.8978 2.10338 15.4374 1.87988 16 1.87988C16.5626 1.87988 17.1022 2.10338 17.5 2.5012C17.8978 2.89903 18.1213 3.43859 18.1213 4.0012Z",
                                  fill: "#F7F9FC"
                                })
                              ], -1)
                            ]), 8, _hoisted_21),
                            _createVNode(_component_LoaderButton, {
                              type: "button",
                              "on-click": () => (_ctx.remove(item)),
                              class: "btn detail__btn"
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createElementVNode("svg", {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 20 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M2 3C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V5C1 5.26522 1.10536 5.51957 1.29289 5.70711C1.48043 5.89464 1.73478 6 2 6H18C18.2652 6 18.5196 5.89464 18.7071 5.70711C18.8946 5.51957 19 5.26522 19 5V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H2Z",
                                    fill: "#F7F9FC"
                                  }),
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7.22 9.22C7.36063 9.07955 7.55125 9.00066 7.75 9.00066C7.94875 9.00066 8.13937 9.07955 8.28 9.22L10 10.94L11.72 9.22C11.7887 9.14631 11.8715 9.08721 11.9635 9.04622C12.0555 9.00523 12.1548 8.98318 12.2555 8.98141C12.3562 8.97963 12.4562 8.99816 12.5496 9.03588C12.643 9.0736 12.7278 9.12974 12.799 9.20096C12.8703 9.27218 12.9264 9.35701 12.9641 9.4504C13.0018 9.54379 13.0204 9.64382 13.0186 9.74452C13.0168 9.84522 12.9948 9.94454 12.9538 10.0365C12.9128 10.1285 12.8537 10.2113 12.78 10.28L11.06 12L12.78 13.72C12.8537 13.7887 12.9128 13.8715 12.9538 13.9635C12.9948 14.0555 13.0168 14.1548 13.0186 14.2555C13.0204 14.3562 13.0018 14.4562 12.9641 14.5496C12.9264 14.643 12.8703 14.7278 12.799 14.799C12.7278 14.8703 12.643 14.9264 12.5496 14.9641C12.4562 15.0018 12.3562 15.0204 12.2555 15.0186C12.1548 15.0168 12.0555 14.9948 11.9635 14.9538C11.8715 14.9128 11.7887 14.8537 11.72 14.78L10 13.06L8.28 14.78C8.13783 14.9125 7.94978 14.9846 7.75548 14.9812C7.56118 14.9777 7.37579 14.899 7.23838 14.7616C7.10097 14.6242 7.02225 14.4388 7.01883 14.2445C7.0154 14.0502 7.08752 13.8622 7.22 13.72L8.94 12L7.22 10.28C7.07955 10.1394 7.00066 9.94875 7.00066 9.75C7.00066 9.55125 7.07955 9.36063 7.22 9.22Z",
                                    fill: "#F7F9FC"
                                  })
                                ], -1)
                              ])),
                              _: 2,
                              __: [11]
                            }, 1032, ["on-click"])
                          ]))
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.add())),
                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.add')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_AndroidAppsPopup, { ref: "androidAppsPopup" }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}